<template>
<div>
	<div class="product-color">
		<div
        class="alert alert-danger product-item__content--edit__error"
        role="alert"
        v-if="errors.length > 0"
      >
        <p v-for="error in errors" :key="error">{{error}}</p>
      </div>
		<div v-if="editFlag">
			<form @submit.prevent="handleEditImage($event)">
			  <p>Edit {{title}}</p>

			  <div class="text-center m-b-20"><input type="file" accept="image/*" required  :data-meta="meta" /></div>
			  <button type="submit" class="btn btn-primary" v-if="loading" disabled>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				Loading
			  </button>
			  <button
				class="btn btn-primary m-r-5"
				type="submit"
				v-else
			  >Save</button>
			  <button class="btn btn-success" @click.prevent="toggleActive()">Cancel</button>
			</form>
		</div>
		<div v-else="">
		<div >
			<div >
				<p>{{title}} : </p>
			</div>
			<div >
				<img :src="img" />
			</div>
		</div>
		<div class="product-color__actions">
			<button class="btn btn-success"  @click="toggleActive()">
					<i class="far fa-edit"></i>
				  </button>
		</div>
	</div>
	</div>
</div>
</template>
<script>
import { globalStore } from '../../main.js';
import { herokuUrl } from "../../apiConfig";
import axios from "axios";
import { getCookie } from "../../cookie.js";
import logOut from "../../scripts/utils";

export default {
	props: ['imgSrc', 'title', 'meta', 'productId'],
	data() {
		return {
			editFlag: false,
			loading: false,
			errors: [],
			img: this.imgSrc
		}
	},
	methods: {
		toggleActive() {
	      this.editFlag = !this.editFlag;
		  this.loading = false;
	    },
		handleEditImage(e){
			this.loading = true;

			this.errors.splice(0,this.errors.length)
			
			// create formdata, get all files and add them to form data, then send them to api
		var bodyFormData = new FormData();
		bodyFormData.append("productId", this.productId); // append current product
		[...e.target.elements].forEach((item)=>{
		if(item.nodeName == 'INPUT'){
      bodyFormData.append("metaType", item.getAttribute('data-meta'));
			bodyFormData.append('product_image', item.files[0]);
		}
	});
      axios({
        method: "POST",
        url: `${herokuUrl}/dashboard/uploadProductImg`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getCookie("user")
        }
      })
        .then(response => {
          if (response.data.status) {
						this.loading = false;
						this.toggleActive()
						this.img = response.data.sources;
						// this.$router.replace({ path: 'manage-product', query: { selectedOrderId:  this.productId} })
						// window.location.replace(window.location.origin + "/manage-product?selectedOrderId=" + this.productId)
          } else {
			  this.errors.push("For files, large file upload is forbidden");
            this.errors.push(response.data.message);
          }
        })
        .catch(err => {
			if(err.response.status == 401) {
				logOut();
			} else {
				// console.log(err);
				this.loading = false;
				this.errors.push(err);
				this.errors.push("For files, large file upload is forbidden");    
			}
        });

		}
	},
	mounted(){}
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_global.scss";

.product-color {
    background: #fff;
    border-radius: 10px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    img {
        height: 300px;
    }
    &__actions {
        margin-top: 10px;
        button {
            cursor: pointer;
        }
    }
}
</style>
